import { sessionStorageHelper } from "@offstreetparking/design-system/utils";
import type { EntrySelection, RecursivePermitFormData } from "./types";

const STORAGE_KEY = "portal_touchnet_pending_checkout";
const MAX_AGE_MS = 30 * 60_000;

// The redirect to uPay unloads the wizard, so its entries are kept for the tab and handed back when
// TouchNet returns the parker to the same wizard URL after a decline, an error or a cancel.
type PendingCheckout = {
	resumePath: string;
	formData: RecursivePermitFormData;
	entrySelection?: EntrySelection;
	stashedAt: number;
};

export const currentResumePath = () => window.location.pathname + window.location.search;

export const stashPendingCheckout = ({
	formData,
	entrySelection,
}: Pick<PendingCheckout, "formData" | "entrySelection">) => {
	const pending: PendingCheckout = {
		resumePath: currentResumePath(),
		formData,
		entrySelection,
		stashedAt: Date.now(),
	};
	sessionStorageHelper.setItem(STORAGE_KEY, pending);
};

export const readPendingCheckout = (): Pick<PendingCheckout, "formData" | "entrySelection"> | undefined => {
	const pending: PendingCheckout | null = sessionStorageHelper.getItem(STORAGE_KEY);
	if (!pending || pending.resumePath !== currentResumePath() || Date.now() - pending.stashedAt >= MAX_AGE_MS) {
		return undefined;
	}
	return { formData: pending.formData, entrySelection: pending.entrySelection };
};

export const clearPendingCheckout = () => sessionStorageHelper.removeItem(STORAGE_KEY);
